<div [innerHTML]="renderValue"></div>